interface CopyableLinkBoxProps {
  url: string;
  /**
   * DOM id, for the dashboard smoke tests that read a link out by id
   * (`#invitationUrl`) rather than a testid. The box's text is only the URL, so
   * `cy.get(...).invoke("text")` returns it clean. New call sites don't need it.
   */
  id?: string | undefined;
}

/**
 * Break glass: a long URL in a bordered, filled field, for the dialogs that
 * hand a customer a link to pass on — the referral link and the add-a-credit-
 * card invitation.
 *
 * The link has to look like something you can select and copy. A bare line of
 * text with a small copy icon trailing it reads as body copy, and the icon is
 * easy to miss entirely — which is what the pre-renovation dialogs avoided by
 * putting the URL in a read-only input with an explicit "click here to copy"
 * link beside it. Pair this with a `CopyToClipboardButton`.
 *
 * Drawn here rather than composed: ui-core has no plain container primitive, and
 * a real `TextInput` is wrong twice over — it renders underlined inside these
 * dialogs' `ControlPresentationProvider`, and a field you can put a cursor in
 * invites editing a value that isn't editable. `select-all` makes one click
 * select the whole URL for the people who'd rather copy it by hand.
 */
export function CopyableLinkBox({ url, id }: CopyableLinkBoxProps) {
  return (
    <span
      {...(id !== undefined && { id })}
      className="min-w-0 flex-1 rounded-md border border-border bg-muted px-3 py-1.5 text-sm break-all text-content select-all"
    >
      {url}
    </span>
  );
}
